import React, { useState, useEffect, useRef } from 'react';
import { Skeleton } from '@mui/material';

interface VideoIframeProps {
  'data-uuid': string;
  style?: React.CSSProperties;
}

const VideoIframe: React.FC<VideoIframeProps> = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const initVidyard = () => {
      if (window.VidyardV4?.api?.renderPlayer) {
        window.VidyardV4.api.renderPlayer({
          uuid: props['data-uuid'] as string,
          container: containerRef.current,
        });
        setIsLoading(false);
      }
    };

    // Check if Vidyard is already loaded
    if (window.VidyardV4?.api?.renderPlayer) {
      initVidyard();
    } else {
      // Listen for Vidyard to load
      window.addEventListener('onVidyardAPI', initVidyard);
      return () => window.removeEventListener('onVidyardAPI', initVidyard);
    }
  }, [props['data-uuid']]);

  return (
    <>
      {isLoading && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          }}
        />
      )}
      <div 
        ref={containerRef}
        style={{ width: '100%', height: '100%', backgroundColor: 'white' }}
      />
    </>
  );
};

export default VideoIframe;
